module.exports = __webpack_public_path__ + "img/ep2-11.70a8a5c7.png";